/**
 * @GENERATED from Figma node 3608:51042
 */

import { useUniqueInlineId } from "@inline-svg-unique-id/react";
import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const TrelloDark = function (props: IconProps, ref: React.Ref<SVGSVGElement>) {
  const _id = useUniqueInlineId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      focusable={false}
      role="presentation"
      ref={ref}
      {...props}
    >
      <path
        fill={`url(#${_id})`}
        d="M20.047 2H3.953A1.953 1.953 0 0 0 2 3.953v16.094C2 21.126 2.874 22 3.953 22h16.094A1.953 1.953 0 0 0 22 20.047V3.953A1.953 1.953 0 0 0 20.047 2"
      />
      <path
        fill="#fff"
        d="M18.462 4.6h-4.225a.94.94 0 0 0-.937.937v6.876c0 .517.42.937.937.937h4.225c.518 0 .938-.42.938-.937V5.536a.937.937 0 0 0-.938-.937M9.763 4.6H5.538a.937.937 0 0 0-.938.937v11.876c0 .517.42.937.938.937h4.225c.517 0 .937-.42.937-.937V5.537a.937.937 0 0 0-.937-.937"
      />
      <defs>
        <linearGradient
          id={_id}
          x1={12}
          x2={12}
          y1={2}
          y2={22}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0091E6" />
          <stop offset={1} stopColor="#0079BF" />
        </linearGradient>
      </defs>
    </svg>
  );
};
const ForwardRef = React.forwardRef(TrelloDark);
export { ForwardRef as TrelloDark };
